import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface LoadingDotsProps {
  awaitMessage?: string;
  flightSearchMessage?: string;
}

export const LoadingDots = ({
  awaitMessage,
  flightSearchMessage,
}: LoadingDotsProps) => (
  <div className="min-h-[24px] relative">
    <AnimatePresence mode="wait">
      {flightSearchMessage ? (
        <motion.p
          key="flight"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="text-neutral-700 font-medium px-1 pt-1 flex items-center"
        >
          {flightSearchMessage}
        </motion.p>
      ) : awaitMessage ? (
        <motion.p
          key="await"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="text-neutral-700 font-medium px-1 pt-1"
        >
          {awaitMessage}
        </motion.p>
      ) : (
        <motion.div
          key="dots"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="absolute bottom-2 -right-2 flex items-center space-x-1.5"
        >
          {[0, 0.1, 0.2].map((delay, i) => (
            <motion.div
              key={i}
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{
                repeat: Infinity,
                duration: 0.6,
                delay: delay,
                ease: "easeInOut",
              }}
              className="w-2 h-2 bg-indigo-800 rounded-full"
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);
